import { VideoElementDto } from "@repo/api/overlays";
import { Video } from "@remotion/media";
import { getMediaSrc } from "../../utils/media.ts";
import { AssetMediaAsyncDto } from "@repo/api/asset-media";
import { OffthreadVideo } from "remotion";

type Props = {
  element: VideoElementDto;
  assetMedias: Record<string, AssetMediaAsyncDto>;
};

export default function VideoElement({ element, assetMedias }: Props) {
  const assetMedia = assetMedias[element.assetMediaExternalId];

  if (!assetMedia || assetMedia.status !== "COMPLETED") {
    return null;
  }

  const isTransparent = assetMedia.data.isTransparentVideo ?? false;
  const volume = element.volume ?? 1;

  // Lambda renderer runs out of memory when using the Video component with transparent videos.
  if (isTransparent) {
    return (
      <OffthreadVideo
        src={getMediaSrc(assetMedia.data.src)}
        className="h-full w-full object-cover object-top-left"
        pauseWhenBuffering={true}
        delayRenderTimeoutInMilliseconds={1000 * 90}
        transparent
        volume={volume}
      />
    );
  }

  return (
    <Video
      src={getMediaSrc(assetMedia.data.src)}
      className="h-full w-full"
      objectFit="cover"
      style={{
        objectPosition: "top left",
      }}
      delayRenderTimeoutInMilliseconds={1000 * 90}
      volume={volume}
    />
  );
}
